;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import Link from 'components/ui/Link';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import styles from './CardLocation.module.scss';

const logoMap = {
    Market: 'market',
    Creamery: 'creamery',
};

const CardLocation = ({
    location,
    logo,
    address,
    linkToGoogleMaps,
    linkToReservation,
    hours,
    descriptionLine1,
    descriptionLine2,
    descriptionLine3,
    linkToLearnMore,
    linkToMenu,
    contactName,
    contactEmail,
    contactNumber,
}) => {
    return (
        <div
            className={cx(styles.locationCard, {
                [styles.market]: logoMap[location] === 'market',
            })}
        >
            {location && !logo && (
                <div className={styles.logoWrapper}>
                    <SvgIcon type={logoMap[location]} />
                </div>
            )}
            {logo?.url && (
                <div className={styles.logoWrapper}>
                    <img src={logo.url} alt="" />
                </div>
            )}
            {address && linkToGoogleMaps && (
                <div className={styles.address}>
                    <Link href={linkToGoogleMaps}>
                        <Text
                            baseTheme="bodySmall"
                            themes={{ large: 'bodyMedium' }}
                        >
                            {address}
                        </Text>
                    </Link>
                </div>
            )}
            {linkToReservation && (
                <div>
                    <ButtonCTA
                        className={styles.reservationButton}
                        {...linkToReservation}
                        text="Make A Reservation"
                        style="outlined-blue-blue"
                    />
                </div>
            )}
            <div className={styles.hoursWrapper}>
                {hours && (
                    <div>
                        <Text
                            className={styles.hoursLabel}
                            baseTheme="labelLarge"
                        >
                            Hours
                        </Text>
                    </div>
                )}
                <div>
                    <ul className={styles.hoursList}>
                        {hours &&
                            hours.map(({ days = '', hours = '' }, idx) => (
                                <li key={idx}>
                                    <div className={styles.timeSpan}>
                                        <Text baseTheme="headingXSmall">
                                            {days}
                                        </Text>
                                        <Text baseTheme="headingXSmall">
                                            {hours?.replace(/\|/g, '\n')}
                                        </Text>
                                    </div>
                                </li>
                            ))}
                    </ul>
                </div>
                <div>
                    <Text baseTheme="bodyXSmall">
                        {descriptionLine1 && descriptionLine1}
                        {descriptionLine2 && (
                            <>
                                <br />
                                {descriptionLine2}
                            </>
                        )}
                        {descriptionLine3 && (
                            <>
                                <br />
                                {descriptionLine3}
                            </>
                        )}
                    </Text>
                </div>
            </div>
            <div className={styles.contactWrapper}>
                {(contactName || contactNumber) && (
                    <Text
                        className={styles.contactLabel}
                        baseTheme="labelLarge"
                    >
                        Contact
                    </Text>
                )}

                {contactName && (
                    <Text
                        className={styles.contactName}
                        baseTheme="headingXSmall"
                    >
                        {contactName}
                    </Text>
                )}

                {contactEmail && (
                    <Link
                        className={styles.contactEmail}
                        href={`mailto:${contactEmail}`}
                    >
                        <Text baseTheme="headingXSmall">{contactEmail}</Text>
                    </Link>
                )}
                {contactNumber && (
                    <Link
                        className={styles.contactNumber}
                        href={`tel:${contactNumber}`}
                    >
                        <Text baseTheme="headingXSmall">{contactNumber}</Text>
                    </Link>
                )}
            </div>
            <div>
                <div className={styles.buttonWrapper}>
                    <ButtonCTA
                        className={styles.learnMoreLink}
                        link={linkToLearnMore}
                        text="Learn more"
                        style="filled-blue-ocean"
                    />
                    {linkToMenu?.assetDownloadLink && (
                        <ButtonCTA
                            className={styles.menuButton}
                            {...linkToMenu}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

CardLocation.propTypes = {
    address: PropTypes.string,
    contactEmail: PropTypes.string,
    contactName: PropTypes.string,
    contactNumber: PropTypes.string,
    descriptionLine1: PropTypes.string,
    descriptionLine2: PropTypes.string,
    descriptionLine3: PropTypes.string,
    hours: PropTypes.array,
    linkToGoogleMaps: PropTypes.string,
    linkToLearnMore: PropTypes.object,
    linkToMenu: PropTypes.object,
    linkToReservation: PropTypes.string,
    location: PropTypes.oneOf(['Market', 'Creamery']),
    logo: PropTypes.object,
};

export default CardLocation;
